import { getCurrentIsoWeek } from './dateUtils';

export type TreatmentPlanStatus = 'active' | 'upcoming' | 'past';

interface PlanRange {
  year: number;
  startWeek: number;
  endWeek: number;
}

export function getTreatmentPlanStatus(plan: PlanRange): TreatmentPlanStatus {
  const currentYear = new Date().getFullYear();
  const currentWeek = getCurrentIsoWeek();

  if (plan.year < currentYear) return 'past';
  if (plan.year > currentYear) return 'upcoming';
  if (plan.endWeek < currentWeek) return 'past';
  if (plan.startWeek > currentWeek) return 'upcoming';
  return 'active';
}

export function comparePlansByStartAsc(a: PlanRange, b: PlanRange): number {
  if (a.year !== b.year) return a.year - b.year;
  return a.startWeek - b.startWeek;
}

export function comparePlansByEndDesc(a: PlanRange, b: PlanRange): number {
  if (a.year !== b.year) return b.year - a.year;
  return b.endWeek - a.endWeek;
}
